import {
    LOGIN_INVALID,
    REGISTER_EMAIL_EXISTS,
    REGISTER_USERNAME_NOT_AVAILABLE,
} from "opp-api-lib-js";

export const DOLLAR_IN_CENTS = 100;
export const BASE_10 = 10;

export const SERVER_ERROR = "SERVER_ERROR";
export const EMAIL_REQUIRED = "EMAIL_REQUIRED";
export const EMAIL_INVALID = "EMAIL_INVALID";
export const PASSWORD_INVALID = "INVALID_PASSWORD";
export const USERNAME_TOO_LONG = "USERNAME_TOO_LONG";
export const USERNAME_TOO_SHORT = "USERNAME_TOO_SHORT";
export const USERNAME_NO_SYMBOLS = "USERNAME_NO_SYMBOLS";
export const PASSWORD_CONFIRM_MISMATCH = "PASSWORD_CONFIRM_MISMATCH";

export {
    LOGIN_INVALID,
    REGISTER_EMAIL_EXISTS,
    REGISTER_USERNAME_NOT_AVAILABLE,
};



// WEBPACK FOOTER //
// ./src/constants.ts